import { HostMessageType } from '../../interfaces/host-message-types';
import { sendMessageToHost } from '../base/models/base-message';
import { MessageHandler } from '../base/interfaces/message.interface';
import { AddNewModelPayload } from './interfaces/add-new-model-payload.interface';
import { isNonNullObject } from 'utilities';

export const AddNewModelMessage: MessageHandler<AddNewModelPayload> = {
  send(payload: AddNewModelPayload, targetOrigin = '*'): void {
    sendMessageToHost(HostMessageType.AddNewModel, payload, targetOrigin);
  },

  validatePayload(payload: unknown): payload is AddNewModelPayload {
    return (
      isNonNullObject(payload) &&
      'teamId' in payload &&
      (payload.teamId === undefined || typeof payload.teamId === 'string') &&
      'projectId' in payload &&
      (payload.projectId === undefined || typeof payload.projectId === 'string') &&
      'name' in payload &&
      (payload.name === undefined || typeof payload.name === 'string')
    );
  },
};
